/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';
import { ValidationService } from '../../services';

@Directive({
    selector: '[appHostnameValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: HostnameValidationDirective, multi: true }]
})

/**
 * @name HostnameValidationDirective
 * @description
 * ## Validation rules:
 * - hostname does not start and/or end with a hyphen (-).
 * - contains only a-z, A-Z and 0-9, can be hyphenated.
 * - does not contain only numbers.
 * - does not contain dots (.).
 * - can be 1-63 characters in length.
 *
 * @see {@link https://en.wikipedia.org/wiki/Hostname}
 * @see {@link https://regex101.com/r/G6Fhkj/1}
 */
export class HostnameValidationDirective implements Validator {
    public validate(control: AbstractControl): { [key: string]: any } | null {
        return hostnameValidation(control);
    }
}

/**
 * Hostname validation.
 * @param control
 * @returns {{hostnameValidation: string} | null}
 */
export function hostnameValidation(control: any): any {
    return (
        !control?.value ||
        ValidationService.hostNameCheck(control?.value)
    ) ? null : {
        'hostnameValidation': 'hostname_validation_error_message'
    };
}
